// src/services/employees/employeeCompensationService.ts
import { supabase } from '@/lib/supabase';

export interface EmployeeCompensation {
    id: string;
    shop_id: number;
    hairdresser_id: string;
    salary_monthly: number | null;
    salary_annual: number | null;
    thirteenth: boolean;
    fourteenth: boolean;
    tfr: boolean;
    note: string | null;
    created_at: string;
    updated_at: string;
}

/**
 * Costo mensile medio del dipendente, ratei inclusi.
 * mensilità = 12 + 13ª + 14ª; TFR ≈ retribuzione annua lorda / 13.5 (quota annua), spalmato sul mese.
 */
export const monthlyCostFromCompensation = (c: {
    salary_monthly?: number | null;
    thirteenth?: boolean | null;
    fourteenth?: boolean | null;
    tfr?: boolean | null;
}): number => {
    const base = Number(c.salary_monthly) || 0;
    if (base <= 0) return 0;
    const mensilita = 12 + (c.thirteenth ? 1 : 0) + (c.fourteenth ? 1 : 0);
    const annualGross = base * mensilita;
    const tfrAnnual = c.tfr ? annualGross / 13.5 : 0;
    return (annualGross + tfrAnnual) / 12;
};

// Tutti i compensi del salone (uno per dipendente, al massimo).
export const fetchCompensationsService = async (shopId: number) => {
    const { data, error } = await supabase
        .from('EmployeeCompensation')
        .select('*')
        .eq('shop_id', shopId);
    if (error) return { success: false, error: error.message, data: [] as EmployeeCompensation[] };
    return { success: true, data: (data || []) as EmployeeCompensation[] };
};

// Upsert del compenso di un dipendente (una riga per hairdresser_id).
export const upsertCompensationService = async (payload: {
    shop_id: number;
    hairdresser_id: string;
    salary_monthly?: number | null;
    salary_annual?: number | null;
    thirteenth?: boolean;
    fourteenth?: boolean;
    tfr?: boolean;
    note?: string | null;
}) => {
    const { data, error } = await supabase
        .from('EmployeeCompensation')
        .upsert({ ...payload, updated_at: new Date().toISOString() }, { onConflict: 'hairdresser_id' })
        .select()
        .single();
    if (error) return { success: false, error: error.message };
    return { success: true, data: data as EmployeeCompensation };
};
